module.exports = __webpack_public_path__ + "static/media/instructor-successful-teams2.c1182c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-successful-teams2.png
// module id = 2591
// module chunks = 0